"use client"

import { Search } from "lucide-react"

interface ExplorerSearchBarProps {
  value: string
  onChange: (value: string) => void
}

export function ExplorerSearchBar({ value, onChange }: ExplorerSearchBarProps) {
  return (
    <div className="relative mb-8">
      <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={20} />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search for careers, modules, or skills.8.."
        className="w-full pl-12 pr-4 py-4 rounded-xl bg-white border border-slate-200 text-slate-900 placeholder-slate-400 focus:ring-2 focus:ring-blue-600 focus:border-blue-600 outline-none transition"
      />
    </div>
  )
}
